import React from 'react';

import CreateItinerary, {
  ICreateItineraryProps,
} from '../CreateItinerary/CreateItinerary';

interface IEditItineraryProps extends ICreateItineraryProps {}

const defaultProps: IEditItineraryProps = {
  // @ts-ignore
  budgetConfig: {},
  editing: true,
  visible: false,
  onClose: () => {},
  onSubmit: () => {},
  vatTypes: [],
};

const EditItinerary = (props: IEditItineraryProps = defaultProps) => {
  return <CreateItinerary {...props} />;
};

export default EditItinerary;
